<template>
    <v-card :id="id" color="grey lighten-2" class="mt-3">
        <psi-card-heading
            :headingTitle="title"
            :icon="icon"
            :heading-color="headingColor"
        ></psi-card-heading>
        <v-card-text>
            <v-row>
                <v-col cols="12" lg="6">
                    <div class="d-flex align-center">
                        <h3 class="mt-2">{{ applicant.name }}</h3>
                        <v-chip
                            class="ml-2"
                            color="accent lighten-2 font-weight-bold mt-2"
                            label
                            >ORDER ID: {{ applicant.order_id }}</v-chip
                        >
                        <v-spacer></v-spacer>
                        <v-switch
                            v-if="can('orders.edit')"
                            label="Edit"
                            class="text-uppercase font-weight-bold"
                            color="accent darken-2"
                            v-model="edit"
                        ></v-switch>
                    </div>
                    <v-slide-x-transition>
                        <applicant-edit-form :applicant="applicant" v-if="edit">
                        </applicant-edit-form>
                    </v-slide-x-transition>
                    <v-slide-x-reverse-transition>
                        <psi-detail-card
                            v-if="!edit"
                            hide-heading
                            :items="items"
                            class="mt-4"
                        ></psi-detail-card>
                    </v-slide-x-reverse-transition>
                </v-col>
                <v-col cols="12" lg="6">
                    <applicant-files
                        :files="applicant.files"
                        v-if="can('orders.edit')"
                    />

                    <applicant-verify v-if="can('orders.edit')" />
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script>
import ApplicantEditForm from "./Applicant/ApplicantEditForm.vue";
import ApplicantFiles from "./Applicant/ApplicantFiles.vue";
import ApplicantVerify from "./Applicant/ApplicantVerify.vue";
export default {
    name: "screening-process-applicant",
    components: {
        ApplicantEditForm,
        ApplicantFiles,
        ApplicantVerify,
    },
    props: {
        id: {
            type: String,
            required: false,
            default: "screening-applicant",
        },
        headingColor: {
            type: String,
            required: false,
            default: "primary",
        },
        title: {
            type: String,
            required: false,
            default: "Blank",
        },
        icon: {
            type: String,
            required: false,
            default: "mdi-card-text",
        },
        height: {
            type: [String, Number],
            required: false,
            default: 600,
        },
        maxHeight: {
            type: Number,
            required: false,
            default: 200,
        },
        applicant: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            items: [],
            edit: null,
        };
    },
    computed: {
        cssVars() {
            return {
                "--ps-height": this.maxHeight + "px",
            };
        },
    },
    watch: {
        applicant: {
            immediate: true,
            handler(applicant) {
                this.setApplicantData(applicant);
            },
        },
    },
    methods: {
        setApplicantData(applicant) {
            [
                {
                    label: "First Name",
                    key: "contact.first_name",
                },
                {
                    label: "Middle Name",
                    key: "contact.middle_name",
                },
                {
                    label: "Last Name",
                    key: "contact.last_name",
                },
                {
                    key: "type",
                },
                {
                    key: "email",
                },
                {
                    key: "phone",
                },
                {
                    key: "birthdate",
                },
                {
                    key: "ssn_mask",
                    label: "SSN",
                },
            ].forEach((item) => {
                this.items.push({
                    icon: this.$config(`icons.${item.key.split(".").pop()}`),
                    label: this.$_.get(item, "label", "")
                        ? item.label
                        : this.$_.titleCase(item.key),
                    text: this.$_.get(applicant, item.key, ""),
                });
            });
        },
    },
};
</script>

<style scoped>
.ps {
    height: var(--ps-height);
}
</style>